import LazyLoad from "vanilla-lazyload";

document.addEventListener("DOMContentLoaded", function () {
    const lazyContent = new LazyLoad({
        threshold: 150,
    });
});